import type { IdAccountDto, IdContactDto } from '@/services/ws-crm/src/main/resources/rest-api';

export interface AccountDetailsRouteParams {
  accountId: IdAccountDto;
}

export interface ContactFormRouteParams {
  contactId?: IdContactDto;
}

export enum ContactFormSearchParams {
  ACCOUNT_ID = 'accountId',
  REDIRECT_TO = 'redirectTo',
}

export interface AccountFormRouteParams {
  accountId?: IdAccountDto;
}
